import { render } from "./StudentDetailsCardFields.vue?vue&type=template&id=3ec26d2e"
import script from "./StudentDetailsCardFields.vue?vue&type=script&lang=js"
export * from "./StudentDetailsCardFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__